<template>
  <div class="search-result-content" v-if="Object.entries(filterResult).length > 0 && showFilter">
    <strong> {{ trans.global.search_result_for }} : </strong>
    <span v-for="(index, result) in filterResult"><label class="badge badge-pill badge-secondary text-white ml-2">   {{ trans[page].fields[result] }} : {{ index }}</label></span>
    <br>
    <span class="text-muted text-md-center"> About <label style="font-size: 10px" class="badge badge-info text-white ml-2 mr-2">   {{total}} </label> results    </span>
  </div>
</template>

<script>
export default {
  props: {
    searchingKeys : {
      type: Object,
      default: {},
    },
    page : {
      type: String,
      default: 'users',
    },
    showFilter : {
      type: Boolean,
      default: false
    },
    total : {
      type: Number,
      default: 0
    }
  },
  computed: {
    trans() {
      return this.$store.getters.GET_TRANS;
    },
    filterResult() {
      const asArray = Object.entries(this.searchingKeys);
      const filtered = asArray.filter(([key, value]) => value !== null && value !== '');
      return Object.fromEntries(filtered);
    }
  }
};
</script>

<style>
.search-result-content {
  border: 1px dotted #777373;
  padding: 15px;
  margin-bottom: 24px;
  border-radius: 10px;
}
</style>
